import type { ObservedConversationSseFrame } from "./idaChatStreamConfig";

export type DocumentJobBindings = Record<string, string>;

export function documentJobBindingKey(
  conversationId: string | number,
  toolCallId: string,
): string {
  return `${String(conversationId)}:${toolCallId}`;
}

export function recordDocumentJobBinding(
  bindings: DocumentJobBindings,
  frame: ObservedConversationSseFrame,
): DocumentJobBindings {
  if (
    frame.type !== "job_started" ||
    frame.conversation_id == null ||
    !frame.call_id ||
    !frame.job_id ||
    (frame.skill_name !== "generate_document" &&
      frame.skill_name !== "generate_presentation")
  ) {
    return bindings;
  }

  const key = documentJobBindingKey(frame.conversation_id, frame.call_id);
  return bindings[key] === frame.job_id
    ? bindings
    : { ...bindings, [key]: frame.job_id };
}

export function getDocumentJobIdForToolCall(
  bindings: DocumentJobBindings,
  conversationId: string | number | null,
  toolCallId: string,
): string | undefined {
  if (conversationId == null) return undefined;
  return bindings[documentJobBindingKey(conversationId, toolCallId)];
}

export interface BackgroundDocumentJobLike {
  jobId: string;
  status: "pending" | "running" | "completed" | "failed" | "cancelled";
  result?: Record<string, unknown>;
  error?: string;
}

export function getDocumentJobForExecution(
  execution: {
    id: string;
    name: string;
    result?: Record<string, unknown>;
  },
  conversationId: string | number | null,
  bindings: DocumentJobBindings,
  jobs: BackgroundDocumentJobLike[],
): BackgroundDocumentJobLike | undefined {
  if (
    execution.name !== "generate_document" &&
    execution.name !== "generate_presentation"
  ) {
    return undefined;
  }

  const jobId =
    (typeof execution.result?.job_id === "string"
      ? execution.result.job_id
      : undefined) ??
    getDocumentJobIdForToolCall(bindings, conversationId, execution.id);
  return jobId ? jobs.find((job) => job.jobId === jobId) : undefined;
}
